import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
/**
 * If the next query appears in the store or there are not more connection that
 * are using the previous query we should sent "Unsubscribe" message
 * @param nextQueryID {string | undefined} - ID in the store of the currently applied query
 * @param prevQuery {string | undefined} - The previous query from the store
 * @returns {boolean}
 */
export function shouldUnsubscribe(nextQueryID, prevQuery) {
    return typeof nextQueryID !== "undefined" || (typeof prevQuery !== "undefined" &&
        // No more connections are using the previous query
        SDQuerySubscribersStore.getConnectionsForQuery(prevQuery).length === 0);
}
//# sourceMappingURL=shouldUnsubscribe.js.map